<template>
  <div class="mall-sub-title">{{ label }}</div>
</template>

<script>
// 영역 / 입력 항목 제목 (14px SemiBold)
export default {
  name: 'MallSubTitle',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-sub-title {
  padding: 0 4px;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallSubTitle.vue